module.exports = __webpack_public_path__ + "img/4.7b571d24.jpg";